import React, {FunctionComponent} from "react";
import {Button, Box, makeStyles} from "@material-ui/core";
import Text from "../commonComponents/Text";
import {I18n} from "aws-amplify";
import * as H from "history";

const useStyles = makeStyles(() => ({
    menuButton: {
        marginRight: 60,
        padding: 0,
        minWidth: 0
    }
}));

const ButtonGroup: FunctionComponent<{location: H.Location}> = ({location}) => {

    const classes = useStyles();

    return (
        <Box>
            <Button
                className={classes.menuButton}
                target="_blank"
                href={`https://www.ankaufperpost.com/#ueber-uns/${location.search}`}
            >
                <Text value={I18n.get("topBar").whatIsIt} size={18}/>
            </Button>
            <Button
                className={classes.menuButton}
                target="_blank"
                href={`https://www.ankaufperpost.com/#wie-funktioniert/${location.search}`}
            >
                <Text value={I18n.get("topBar").howDoesItWork} size={18}/>
            </Button>
            <Button
                className={classes.menuButton}
                target="_blank"
                href={`https://www.ankaufperpost.com/#faq/${location.search}`}
            >
                <Text value={I18n.get("topBar").faq} size={18}/>
            </Button>
        </Box>
    );
};

export default ButtonGroup;
